export const style = {
	container: {
		minWidth: 600,
	},
};
